<!-- ======= Header ======= -->
<header id="header" class="fixed-top">
	<div class="container  align-items-center">
	  <div class="row">
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
		<h1 class="logo mr-auto img-responsive fl mt"><a href="https://www.hdfcsec.com/" target="_blank"><img src="./assets/images/landing-img/HslDaoLpNewImg/hsl_logo.png" alt="HDFC securities." ></a></h1>
		  
		</div>
		<div class="clearfix"></div>
		
	  </div>
	</div>
   
  </header>
  <!-- End Header -->
  
  <main id="main">
	<section class="bgmain">
	 <div class="container">
		<div class="row">
		
		  <div class="col-sm-12 col-md-12 col-lg-12 wow fadeInDown" data-wow-delay="300ms">
		   
			<h1 class="open">Open DEMAT &amp; TRADING Account in just 10 mins*</h1>
			
			
		   
		  </div>
		  <div class="clearfix"></div>
			 
			<!-- <div class="col-lg-5 col-md-4 col-sm-12"  > <img class="img-responsive intro" alt="HDFC Securities Account" src="images/curve.png" data-holder-rendered="true" style="margin:0 auto;"> </div> -->
		  <div class="col-lg-12 col-md-12 col-sm-12  wow fadeInDown" data-wow-delay="300ms"  > <img class="img-responsive intro" alt="₹20 Per order for
  Futures & Options, Upto 4X Margin for 275 trading days
  with Margin Trading Facility, ₹5 Lacs Same day payout with NO additional cost" src="./assets/images/landing-img/HslDaoLpNewImg/women2.jpg" data-holder-rendered="true" style="margin:0 auto;"> </div>
	  
	  </div>
	   <div class="row">
	   
	  <div class="col-lg-12 col-md-12 col-sm-12 wow fadeInDown" data-wow-delay="300ms"  > 
	   <div class="  formb">
	   <div class="col-lg-12 col-md-12 col-sm-12 text-center formcontainer"  > 
	   <div  class="fixme">
		<fieldset id="eotp">
	  <form class="form-inline" action="#" style="display:block;">
   <div class="form-group">
	  <input type="text" class="form-control" placeholder="Enter your 10 digit mobile no." id="txtMobile" name="txtMobile" [(ngModel)]="loginDetails.Mobile" maxlength="10" onkeypress="return !isNaN(event.key) || event.charCode == 13" autocomplete="off" />
	   
	  <button type="submit" class="btn btn-danger btn-lg startj" (click)="doLogin()">Open an Account</button>
	  </div>
	  </form>
	  </fieldset>
	  <fieldset id="otpdiv" style="display: none;">
	  <form class="form-inline" action="#" style="display:block;">
	  <div class="form-group">
  <p>6 digit code has been sent via SMS on <br>******7095 &amp; email on dum******u@gmail.com</p> 
	 </div>
   <div class="form-group">
	 
	  <input type="text" class="form-control" id="OTP" placeholder="Enter your OTP" maxlength="6"  pattern="\d{6}"  required="">  
	   
	  <button type="submit" class="btn btn-danger btn-lg startj">Verify OTP</button>
	  </div>
	  <div class="form-group">
	  <div class="errorBlock FULoginID">
		<a href="#" >Back</a> | <a href="#" >Resend OTP</a>
										
										  </div>
										  </div>
	  </form>
  
		  </fieldset>
	  <div class="col-lg-12 mt-2 text-center">
			<!-- <h5 class="note">Note: This journey is for regular DEMAT Account. For BSDA (Basic Services Demat Account). Kindly proceed with physical application at your nearest branch.</h5> -->
		  </div>
	  </div>
	  </div>
	  </div>
  </div>
  </div>
  </div>
	</section>
	<!-- End Breadcrumbs -->
  
  
	<section>
	 
	 
	  <div class="container">
		<div class="row wow fadeInUp" data-wow-delay="500ms">
		  <div class="col-lg-12  mt-2 text-center">
			
			  <h2 class="dta1"><span style="color:#024289;">Plans that suit your Trading style</span></h2>
			  <div class="bl1"></div>
			   <h4 class="fdta text-center"> Futures and Options  &#8377;20 per order  |  &#8377;5 Lacs same day payout without additional cost </h4>
		  </div>
		</div>
	  
	  
		<div class="row">
		 <div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		   <img class="img-responsive vplans" alt="Plans that suit your Trading style"  src="./assets/images/landing-img/HslDaoLpNewImg/plan.png" data-holder-rendered="true" style="margin:0 auto;">
	   </div>
	   </div>
  
	   <div class="row wow fadeInUp" data-wow-delay="500ms">
		 <div class="col-lg-12 mb-12 mt-2 text-center mobile wow fadeInUp" data-wow-delay="600ms">
			  <h3 class="planimgtxtAM">&#x2B50;Most Subscribed
  </h3>
			  <div class="table mobile-accordion table-borderless">
				<div class="thead">
					  <div class="tr">
							
												<div class="th planH">Scheme Name</div>
												 <div class="th planH">Value Plan Charges</div>
												<div class="th planH">Free Equity Delivery Volume**</div>
												<div class="th planH">Free Equity Delivery Volume Validity##</div>
												<div class="th planH">Equity Delivery</div>
												<div class="th planH">Equity Intraday</div>
												<div class="th planH">Options <br/>(Per Order)</div>
						  <div class="th planH"  style="border-right: 0px;">Futures <br/>(Per Order)</div>
  
					  </div>
				</div>
				<div class="tbody">
					  <div class="rh active"><span class="pl">Traders Delight: <br/>Value 20</span></div>
					  <div class="tr">
											  <div class="td plantxt" data-header="Value Plan Charges:"> ₹50,000</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹4 Crs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 360 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.20%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.020%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
											   
					  </div>
					 <div class="rh"><span>Traders Delight :<br/>Value 25&#x2B50;</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹25,000</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹1.5 Crs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 360 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.25%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.025%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					  <div class="rh "><span>Investors Choice:<br/>Alpha 4999</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹4,999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹2 Lacs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.10%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.010%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					<div class="rh "><span>Investors Choice:<br/>Alpha 2999&#x2B50;</span></div>
					  <div class="tr">
											  
												  <div class="td plantxt" data-header="Value Plan Charges:"> ₹2,999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹1.5 Lacs</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.15%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.015%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
				  
					   <div class="rh "><span>Starter Pack:<br/>Lite 999</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹999</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹75,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.22%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.022%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					   <div class="rh "><span>Starter Pack:<br/>Lite 299&#x2B50; </span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹299</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹50,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.27%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.027%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
					   <div class="rh "><span>Starter Pack:<br/>Lite 199</span></div>
					  <div class="tr">
											  
												 <div class="td plantxt" data-header="Value Plan Charges:"> ₹199</div>
												 <div class="td plantxt" data-header="Free Equity Delivery Volume**:"> ₹25,000</div>
												  <div class="td plantxt" data-header="Free Equity Delivery Volume Validity##:"> 30 days</div>
												<div class="td plantxt" data-header="Equity Delivery:">0.32%</div>
												<div class="td plantxt" data-header="Equity Intraday:">0.032%</div>
												<div class="td plantxt" data-header="Options (Per Order):">₹20</div>
												<div class="td plantxt" style="border-right: 0px;"  data-header="Futures (Per Order):">₹20</div>
					  </div>
				</div>
		  </div>
			
			  
	   </div>
		  </div>
			   <div class="row wow fadeInUp" data-wow-delay="600ms">
		<div class="col-lg-2 col-md-2 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms">
				 
		  
		  </div> 
				 <div class="col-lg-5 col-md-5 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms">
				 
			<h3 class="planimgtxtA">&#x2B50;Most Subscribed
  </h3>
		  </div>  
		   <div class="col-lg-5 col-md-5 col-sm-12 text-center wow fadeInUp" data-wow-delay="600ms"> 
			<h3 class="planimgtxtB">For Terms and Conditions, <a href="./assets/Pdf/VPTC.pdf" target="_blank" style="text-decoration:underline;">click here</a>.
  </h3>
		  </div>  
		  </div>
		</div>
	</section>
  
	  <section >	
	
		  
	  <div class="container">
	  
	  
	  
		<div class="row wow fadeInUp" data-wow-delay="500ms">
		  <div class="col-lg-12 mb-4 mt-2 text-center">
			<h2 class="dta">Your Investment Account &amp; Endless Opportunities!!!</h2>
			<div class="bl1"></div>
		  </div>
			</div>
		  <div class="row wow fadeInUp bproundA" data-wow-delay="700ms">
			 <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/stockipo.png" alt="Stocks & IPOs" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Stocks &amp; IPOs
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/FO.png" alt="Futures
  & Option" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Futures
  &amp; Options
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/MTF.png" alt="Buy Now, Pay
  Later With MTF" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Buy Now, Pay
  Later With MTF
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/CD.png" alt="Currency &
  Commodities" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Currency &amp;
  Commodities
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/BASKET.png" alt="Basket
  Investing" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Basket
  Investing
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/SLBM.png" alt="SLBM" style="margin:0 auto;">
			<h3 class="bproimgtxtA">SLBM
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/MF.png" alt="Mutual Funds
  & ETFs" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Mutual Funds
  &amp; ETFs
  </h3>
		  </div>
		   <div class="col-lg-3 col-md-3 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive bproimgA " src="./assets/images/landing-img/HslDaoLpNewImg/BUYUS.png" alt="Buy
  US Stocks" style="margin:0 auto;">
			<h3 class="bproimgtxtA">Buy
  US Stocks
  </h3>
		  </div>
		</div>
	  
	  </div>
	  
		</section>
	  
	  
	  <section>	
	
		  
	  <div class="container">
	  
		<div class="row">
		<div class="col-lg-12 mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		<p class="dta1"><span style="color:#024289;">Benefits of trading with our #FaydeKeFeatures </span></p>
			<div class="bl1"></div>
		</div>
		<div class="col-lg-6  mt-2 text-center wow fadeInUp" data-wow-delay="600ms">
		<img class="img-responsive bp" alt="#FaydeKeFeatures"  src="./assets/images/landing-img/HslDaoLpNewImg/fkf.png" data-holder-rendered="true" style="margin:0 auto;">
		</div>
		<div class="col-lg-6 mt-2 text-center">
		<div class="row">
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="700ms"> <img class="img-responsive fkficon" alt="Excel Based Trading"  src="./assets/images/landing-img/HslDaoLpNewImg/ebt.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="advantagth">Excel Based
  Trading</h3>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms"> <img class="img-responsive fkficon" alt="Hold transfer
  releas"  src="./assets/images/landing-img/HslDaoLpNewImg/hold.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="advantagth">Hold Release
  Transfer
  </h3>
		  </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 text-center wow fadeInUp" data-wow-delay="900ms"> <img class="img-responsive fkficon" alt="Theme based investments"  src="./assets/images/landing-img/HslDaoLpNewImg/theme.png" data-holder-rendered="true" style="margin:0 auto;">
			 <h3 class="advantagth">Theme Based
  Investments</h3>
		  </div>
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center  wow fadeInUp" data-wow-delay="1100ms"> 
		   <p class="advantagth" >
		   
			<a href="https://www.hdfcsec.com/fayde-ke-features" target="_blank" style="text-decoration:underline; color:#024289;"><b>Click here</b></a> to Know More
  </p>
		  </div>
		</div>
		</div>
		  
		  
		
		  
	  
		</div>
		  <a href="#dd" class="scroll-down" address="true"></a>
	  </div>
	   
  
	</section>
	
	 <section >
	  <div class="container">
	   
	  
	  
	   <div class="row">
		   <div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp " data-wow-delay="700ms">
			<h2 class="dta1"><span style="color:#024289;">Features of ProTerminal</span></h2>
			<div class="bl1"></div>
			 <h4 class="bprofdta text-center"> Get free^ access to our legendary trading platform </h4>
		   </div>
			 <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			  <div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
			  <div class="bproundR">
			  
			 <img class="img-responsive  " alt="Option Strategy"  src="./assets/images/landing-img/HslDaoLpNewImg/pro.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Option Strategy
  </h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp  " data-wow-delay="800ms">
		   <div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
  <div class="bproundB">
		   <img class="img-responsive " alt="News & Sentiments"  src="./assets/images/landing-img/HslDaoLpNewImg/pro1.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">News &amp; Sentiments
  </h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms"> 
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
		   <div class="bproundR">
		   <img class="img-responsive " alt="Advance Charts"  src="./assets/images/landing-img/HslDaoLpNewImg/pro2.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt"> Advance Charts</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
			<div class="bproundB">
		   <img class="img-responsive " alt="Order Slicing"  src="./assets/images/landing-img/HslDaoLpNewImg/pro3.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Order Slicing</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
		   <div class="bproundB">
		   <img class="img-responsive " alt="Health Score"  src="./assets/images/landing-img/HslDaoLpNewImg/pro4.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Health Score</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp" data-wow-delay="800ms">
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
			<div class="bproundR">
		   <img class="img-responsive " alt="Technical Screener"  src="./assets/images/landing-img/HslDaoLpNewImg/pro5.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Technical Screener</h3>
			</div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms">
			<div class=" bl1proB"></div>
			  <div class=" bl1pro1B"></div>
		   <div class="bproundB">
		   <img class="img-responsive" alt="Overview of F&O market"  src="./assets/images/landing-img/HslDaoLpNewImg/pro6.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Overview of
  F&amp;O market</h3>
  </div>
		  </div>
		   <div class="col-lg-3 col-md-6 col-sm-6 text-center wow fadeInUp " data-wow-delay="800ms"> 
			<div class=" bl1proR"></div>
			  <div class=" bl1pro1R"></div>
		   <div class="bproundR">
		   <img class="img-responsive " alt="Radar"  src="./assets/images/landing-img/HslDaoLpNewImg/pro7.png" data-holder-rendered="true" style="margin:0 auto;">
			<h3 class="bproimgtxt">Radar</h3>
			</div>
		  </div>
		  </div>
		  
  
		   <div class="row wow fadeInUp" data-wow-delay="500ms">
	
			<div class="col-lg-12 md-12 mt-2 text-center wow fadeInUp" data-wow-delay="900ms">
			 <hr/> 
			 <br/>
		   <img class="img-responsive " alt="HDFC securities advantage and Trusted legacy for 20+ Years"  src="./assets/images/landing-img/HslDaoLpNewImg/hsladvantage.jpg" data-holder-rendered="true" style="margin:10 auto;">
		   
		  </div>
	   </div>
	  
	   </div>
  
	</section>
  
	
	<section>
	  <div class="container">
		<div class="row wow fadeInUp" data-wow-delay="600ms">
		  <div class="col-lg-12 mb-4 mt-2 text-center">
			<h2 class="dta1">Our Research Publications<br/>
			</h2>
			<div class="bl1"></div>
			<p class="advantagth" >
			Refer to our various research reports for industry leading actionable insights on sectors and companies.<br/>
			<b>Scan QR to read report.</b>
  
  </p>
  
		  </div>
		</div>
	  </div>
	  <div class="container">
		<div class="row mt-2 ">
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb" data-wow-delay="600ms"> <img class="img-responsive dtimg" alt="India Equity Strategy" src="./assets/images/landing-img/HslDaoLpNewImg/mag1.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">India Equity Strategy:<br/>
  Atma Nirbhar Bharat</h3>
			  
			  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/HslDaoLpNewImg/qr1.png" data-holder-rendered="true" style="width:100px;">
	  
			</div>
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb " data-wow-delay="700ms"> <img class="img-responsive dtimg" alt="PLI: Spearheading India’s" src="./assets/images/landing-img/HslDaoLpNewImg/mag2.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">PLI: Spearheading India’s<br/>
  manufacturing push</h3>
				  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/HslDaoLpNewImg/qr2.png" data-holder-rendered="true" style="width:100px;">
			</div>
		  <div class="col-lg-3 col-md-6 col-sm-12  text-center wow fadeInUp pb " data-wow-delay="800ms"> <img class="img-responsive dtimg" alt="FMCG: D2C" src="./assets/images/landing-img/HslDaoLpNewImg/mag3.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">FMCG: D2C - Changing<br/>
  Landscape Not Fully Factored in</h3>
				  <img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/HslDaoLpNewImg/qr3.png" data-holder-rendered="true" style="width:100px;">
		   </div>
			
		  <div class="col-lg-3 col-md-6 col-sm-12 text-center wow fadeInUp " data-wow-delay="800ms">  <img class="img-responsive dtimg" alt="FinTech Playbook" src="./assets/images/landing-img/HslDaoLpNewImg/mag4.png" data-holder-rendered="true">
			<h3 class="advantagth" style="color:#024289;">FinTech Playbook:<br/>
  Buy Now Pay Later</h3>
		   
				<img class="img-responsive dtimgQR" alt="Scan QR" src="./assets/images/landing-img/HslDaoLpNewImg/qr4.png" data-holder-rendered="true" style="width:100px;">
			</div>
		</div>
	  </div>
	</section>
	 <!-- New Invest Right app -->
	 <section>
    
		<div class="container  wow fadeInUp" data-wow-delay="700ms">
		  
		  <div class="row">
		  
			<div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp vplans1" data-wow-delay="1100ms"> <img class="img-responsive" alt="Introducing our all new power packed investment app! Invest Right Scan the code,<br/>
	to download the app" src="./assets/images/landing-img/HslDaoLpNewImg/mobile.png" data-holder-rendered="true" style="margin:0 auto;width:90%;"> </div>
			
			 <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp pb mobile"  data-wow-delay="800ms">
			 
			  <h3 class="mobiledownload mbline">
			  <p style="font-size:18px;margin-bottom:0px;">Introducing our all new power
	packed investment app!</p>
				  
			  </h3>
			 <img class="img-responsive dtimgQR" alt="Invest Right App" src="./assets/images/landing-img/HslDaoLpNewImg/InvestRightLogo.png" data-holder-rendered="true" style="width:80%;">
				  <img class="img-responsive dtimgQR" alt="Scan QR Download Invest Right App now" src="./assets/images/landing-img/HslDaoLpNewImg/download.png" data-holder-rendered="true" style="width:130px;">
				<p>Scan the code,<br/>
	to download the app</p>
	
			  </div>
		  </div>
		</div>
	 
	  </section>
	  <!-- End New Invest Right app -->
<!--   
	<section>
	  
	  <div class="container  wow fadeInUp" data-wow-delay="700ms">
		
		<div class="row">
		
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp vplans1" data-wow-delay="1100ms"> <img class="img-responsive" alt="1M+ Downloads Scan QR Download Mobile App now 4 Million Happy Customers"  src="./assets/images/landing-img/HslDaoLpNewImg/mobile.png" data-holder-rendered="true" style="margin:0 auto;width:90%;"> </div>
		  
		  <div class="col-lg-12 col-md-12 col-sm-12 text-center wow fadeInUp pb mobile"  data-wow-delay="800ms"> 
			<h3 class="mobiledownload mbline">4 Million Happy Customers</h3>
		   
				<img class="img-responsive dtimgQR" alt="Scan QR Download Mobile App now" src="./assets/images/landing-img/HslDaoLpNewImg/download.png" data-holder-rendered="true" style="width:100px;">
			  <p>Trade on the go!<br/>
  Download Mobile App now!</p>
  
			</div>
		</div>
	  </div>
   
	</section> -->
	<section>
	<div class="container pb  wow fadeInUp" data-wow-delay="800ms">
	 <div class="row wow fadeInUp" data-wow-delay="600ms">
		  <div class="col-lg-12 mt-2 text-center">
			<h2 class="dta1">FAQ’s
			</h2>
			<div class="bl"></div>
		   
		  </div>
		</div>
	<div class="bs-example">
	  <div class="accordion" id="accordionExample">
		  <div class="card">
			  <div class="card-header" id="headingOne" style="background-color:#fff;">
				  <h2 class="mb-0">
					  <button type="button" class="btn btn-link faqh " data-toggle="collapse" data-target="#collapseOne" ><i class="fa fa-angle-right"></i> What is a demat account?</button>									
				  </h2>
			  </div>
			  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
				  <div class="card-body">
					  <p>With a demat account you can convert all your shares from physical holdings to electronic units; this would enable you to access your holdings and transact from anywhere using Internet Banking or Mobile App.  
  </p>
   <p>
  A demat account simplifies share transfers, settlements, allows automatic electronic transfer of dividends and interest and overall management of shares. It also gives you the option of pledging your electronic shares to avail of a loan.</p>
				  </div>
			  </div>
		  </div>
		  <div class="card">
			  <div class="card-header" id="headingTwo" style="background-color:#fff;">
				  <h2 class="mb-0">
					  <button type="button" class="btn btn-link faqh collapsed" data-toggle="collapse" data-target="#collapseTwo"><i class="fa fa-angle-down"></i> What can I do with a Demat &amp; Trading account?</button>
				  </h2>
			  </div>
			  <div id="collapseTwo" class="collapse " aria-labelledby="headingTwo" data-parent="#accordionExample">
				  <div class="card-body">
					  <p> You can dematerialize and invest in the following financial instruments through your HDFC securities Demat and Trading Account.<br/>
  
  
  </p>
  <p><b>Equity </b>- Find a range of convenient trading options in equities such as DIYSIP, e-Margin, Off market, Encash. These options give you a financial flexibility such as buy now pay later, getting funds from sale of stocks on the trading day as against T+2. </p>
  <p><b>Initial Public Offer (IPO)</b> - Apply in IPOs as per your convenience in few clicks or with a call. Track and analyze the forthcoming IPOs to make informed decision. </p>
  <p><b>StockSIP</b> - Tide through a volatile market by investing your money at regular intervals by adopting a disciplined strategy with a systematic investment plan. Through StockSIP, you can buy pre-specified quantity of stocks/units at regular intervals over a period of time. StockSIP option is available in stocks, Gold ETFs and Index ETFs. </p>
  <p><b>Gold ETF</b> - Available in small denominations, invest in dematerialized form of gold. Gold ETF are listed and traded just like stock. You can also avail the option of doing DIYSIP monthly in Gold ETF. </p>
  <p><b>Bonds / NCDs</b> - These instruments offer a higher rate of return. Invest in high rated Bonds and highly liquid NCDs.</p>
  <p><b>Mutual Funds </b>- Brace for a paperless investing experience in Mutual Funds. Purchase and redeem mutual fund units online just like stocks through your trading account. </p>
				  </div>
			  </div>
		  </div>
		
			  
		  </div>
	  </div>
  </div>
  
  </section>
  </main>
  <!-- End #main --> 
  
  <!-- ======= Footer ======= -->
  <footer id="footer">
	<div class="container d-md-flex py-4 wow fadeInUp" data-wow-delay="300ms">
	  <div class="mr-md-auto text-center text-md-left">
		<div class="copyright"> <span>HDFC Securities Ltd.</span>
		  <div class="credits">
			<p> ^^Demat Account free for first year. *Under normal internet speed. Account would be opened after all procedure relating to IPV and client due diligence is completed. Brokerage will not exceed the SEBI prescribed limit. #MTF is subject to the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd. ##Involvement of HDFC Securities Ltd. is restricted to Referral only. HDFC Securities Ltd. does not offer this product directly to customers  <a href="https://www.hdfcsec.com/globalinvesting" target="_blank" style="color:#fff;text-decoration: underline;">https://www.hdfcsec.com/globalinvesting</a>. ^T&C.
   <br/>
			  <br/>
			  
  
  **The free volume offer expires once the said free volume is exhausted or the validity expires, whichever comes first, after which the respective delivery rates mentioned will apply throughout the lifetime of the current offer. ##For Value 20 &amp; Value 25 plans: Free equity delivery volume validity is 360 days. Equity Delivery Brokerage is applicable Post Free Delivery Volume/ Delivery Volume Validity. 
  There are 2 types of Plans (applicable only for resident customers only); <br/>
  i. which is valid for a period of 360 days i.e. Lite &amp; Alpha plans, which are annual auto-renewal plans at the end of the tenure.<br/>
  ii. which comes with a validity of lifetime i.e. Value 20 &amp; Value 25 plans which is payable only once.<br/>
  Kindly note for Derivative brokerage, one should have Derivative Privilege to avail benefit.
   <br/>
			  <br/>
			  Investment in securities market are subject to market risks, read all the related documents carefully before investing.Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors. Mutual fund investments are subject to market risks, read all scheme related documents carefully.<br/>
			  <br/>
			   Please note By submitting the above mentioned details,<br/>
  1. You are authorising us to call you even though you may be registered under DNC. We shall Call/SMS you for a period of 18 months.<br/>
  2. You are opting in to receive Whatsapp communication from us on the above registered mobile number.<br/>
  <br/>
  SEBI Registration No.: INZ000186937 (NSE, BSE,MSEI, MCX) |NSE Trading Member Code: 11094 | BSE Clearing Number: 393 | MSEI Trading Member Code: 30000 | MCX Member Code: 56015 | IN-DP-372-2018 (CDSL, NSDL) | CDSL DP ID: 12086700 | NSDL DP ID: IN304279 | AMFI Reg No. ARN -13549 | PFRDA Reg. No - POP 11092018 | IRDA Corporate Agent Licence No.CA0062 | Research Analyst Reg. No. INH000002475 | Investment Adviser: INA000011538 | CIN-U67120MH2000PLC152193 Registered Address: I Think Techno Campus, Building, B, Alpha, Office Floor 8, Near Kanjurmarg Station, Kanjurmarg (East), Mumbai -400 042. Tel -022 30753400. Compliance Officer: Mr. Murli V Karkera. Ph: 022-3045 3600, Email: complianceofficer@hdfcsec.com.
  
  <br/>
		 <br/>    
  Disclaimer: HDFC Securities Ltd. is a financial services intermediary and is engaged as a distributor of financial products &amp; services like Corporate FDs &amp; Bonds, Insurance, MF, NPS,Real Estate services, Loans, NCDs, IPOs, E-Will &amp; E-Tax in strategic distribution partnerships. Customers need to check products &amp; features before investing since the contours of the product rates may change from time to time. HDFC securities Ltd. is not liable for any loss or damage of any kind arising out of investments in these products. Investments in Equity, Currency, Futures &amp; Options are subject to market risk. Clients should read the Risk Disclosure Document issued by SEBI &amp; relevant exchanges &amp; the T&amp;C on www.hdfcsec.com before investing. Global Investing, Digigold, Insurance, Mutual Funds and NPS are not an approved product of the Exchanges and any dispute related to this will not be dealt at Exchange platform. MTF is subject to the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017 and the terms and conditions mentioned in rights and obligations statement issued by HDFC Securities Ltd.
   <br/>
			  <br/><br/>
			 
			  <br/>
			  <!-- <a data-toggle="modal" href="#exampleModalLong" style="color:#fff;font-size:13px;text-decoration:underline;padding:0px;text-align:center;margin:0 auto;display:block;">Disclaimer</a> </p> -->
		  </div>
		</div>
	  </div>
	</div>
  </footer>
  <!-- End Footer --> 
   
  <!-- <a id="back-to-top" href="#" class="btn btn-light btn-lg back-to-top top" role="button">&#8679;</a>  -->